// extracted by mini-css-extract-plugin
module.exports = {"smsConfirm":"style-module--smsConfirm--3LWaZ","newPass":"style-module--newPass--6NEQs"};